import { useLocation, useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../api/axios';
import styles from './Topbar.module.css';

const SECTION_LABELS = {
  anuncios:       'Anuncios',
  mensajes:       'Mensajes',
  contenidos:     'Contenidos',
  trabajos:       'Trabajos',
  calificaciones: 'Calificaciones',
};

const PAGE_LABELS = {
  admin:    'Panel de Admin',
  perfil:   'Mi Perfil',
  dashboard: null, // Se maneja como "Inicio"
};

export default function Topbar({ onToggle }) {
  const { pathname } = useLocation();
  const params = useParams();
  const [asignatura, setAsignatura] = useState(null);

  const parts   = pathname.split('/').filter(Boolean);
  const section = parts[parts.length - 1];
  const asigId  = params.id;

  // Página especial (admin, perfil, etc.)
  const pageLabel = PAGE_LABELS[section];
  const isSpecialPage = section in PAGE_LABELS || pageLabel !== undefined;

  useEffect(() => {
    if (asigId) {
      api.get(`/asignaturas/${asigId}`)
        .then(r => setAsignatura(r.data.data))
        .catch(() => setAsignatura(null));
    } else {
      setAsignatura(null);
    }
  }, [asigId]);

  const sectionLabel = SECTION_LABELS[section];

  return (
    <header className={styles.topbar}>
      <button className={styles.toggle} onClick={onToggle} aria-label="Toggle sidebar">
        <span /><span /><span />
      </button>

      <nav className={styles.breadcrumb} aria-label="breadcrumb">
        <Link to="/dashboard" className={styles.crumb}>Inicio</Link>

        {/* Páginas especiales: admin, perfil */}
        {!asigId && pageLabel && (
          <>
            <span className={styles.sep}>›</span>
            <span className={styles.crumbActive}>{pageLabel}</span>
          </>
        )}

        {/* Dentro de una asignatura */}
        {asignatura && (
          <>
            <span className={styles.sep}>›</span>
            <Link to={`/asignaturas/${asigId}`} className={styles.crumb}>
              {asignatura.nombre}
            </Link>
          </>
        )}

        {/* Sección dentro de asignatura */}
        {SECTION_LABELS[section] && (
          <>
            <span className={styles.sep}>›</span>
            <span className={styles.crumbActive}>{SECTION_LABELS[section]}</span>
          </>
        )}

        {/* Dashboard — solo "Inicio" sin segundo nivel */}
        {!asignatura && !pageLabel && !SECTION_LABELS[section] && (
          <>
            <span className={styles.sep}>›</span>
            <span className={styles.crumbActive}>Inicio</span>
          </>
        )}
      </nav>
    </header>
  );
}
